<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="w-100">
        <div class="clearfix">
          <h1 class="float-left display-1 mr-4">404</h1>
          <h1 class="pt-3">Oops! </h1>
          <p class="text-muted">La p&aacute;gina que buscas no existe.</p>
        </div>
      </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
  export default {
    name: 'Page404'
  }
</script>
